"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeData = void 0;
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const flattenNodeData = (nodeData) => {
    return nodeData.reduce((acc, node) => {
        acc.push(...node.getDescendants());
        return acc;
    }, []);
};
class NodeData {
    constructor(data, id, depth = 0, isAsync) {
        this.data = data;
        this.id = id;
        this.depth = depth;
        if (isAsync) {
            this.isAsync = function () {
                return isAsync(this);
            };
        }
    }
    static createHierarchy(data, idAccessor, childrenAccessor, isAsync) {
        var _a;
        const root = data.map((data) => new NodeData(data, idAccessor(data), 0, isAsync));
        let current;
        const visitors = [...root];
        while ((current = visitors.pop())) {
            current.children = (_a = childrenAccessor(current.data)) === null || _a === void 0 ? void 0 : _a.map((item) => {
                var _a;
                const newNode = new NodeData(item, idAccessor(item), ((_a = current === null || current === void 0 ? void 0 : current.depth) !== null && _a !== void 0 ? _a : 0) + 1, isAsync);
                newNode.parent = current;
                return newNode;
            });
            visitors.push(...(current.children || []));
        }
        return root;
    }
    static equal(nodesA, nodesB, mapper = (node) => {
        var _a;
        return ({
            id: node.id,
            parentId: (_a = node.parent) === null || _a === void 0 ? void 0 : _a.id,
            data: node.data
        });
    }) {
        return (0, fast_deep_equal_1.default)(mapper(nodesA), mapper(nodesB));
    }
    static equalNodes(nodesA, nodesB, mapper = (node) => {
        var _a;
        return ({
            id: node.id,
            parentId: (_a = node.parent) === null || _a === void 0 ? void 0 : _a.id
        });
    }) {
        return (0, fast_deep_equal_1.default)(flattenNodeData(nodesA).map(mapper), flattenNodeData(nodesB).map(mapper));
    }
    preorderTraverse(callback) {
        var _a, _b;
        let current;
        const visitors = ((_a = this.children) !== null && _a !== void 0 ? _a : []).slice().reverse();
        while ((current = visitors.pop())) {
            callback(current);
            visitors.push(...((_b = current.children) !== null && _b !== void 0 ? _b : []).slice().reverse());
        }
    }
    getById(id) {
        var _a, _b;
        let current;
        const visitors = ((_a = this.children) !== null && _a !== void 0 ? _a : []).slice().reverse();
        while ((current = visitors.pop())) {
            if (current.id === id) {
                return current;
            }
            visitors.push(...((_b = current.children) !== null && _b !== void 0 ? _b : []).slice().reverse());
        }
        return;
    }
    getLeaves() {
        const leaves = [];
        this.preorderTraverse((node) => {
            if (!node.children) {
                leaves.push(node);
            }
        });
        return leaves;
    }
    getAncestors() {
        let parent = this.parent;
        const ancestors = [this];
        while (parent) {
            ancestors.push(parent);
            parent = parent.parent;
        }
        return ancestors;
    }
    getDescendants() {
        const descendants = [this];
        this.preorderTraverse((descendant) => {
            descendants.push(descendant);
        });
        return descendants;
    }
    getSiblings() {
        var _a, _b;
        const siblings = [];
        (_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.forEach((sibling) => {
            if (sibling !== this) {
                siblings.push(sibling);
            }
        });
        return siblings;
    }
    isTerminal() {
        var _a;
        return this.isAsync() ? false : !((_a = this.children) === null || _a === void 0 ? void 0 : _a.length);
    }
    isAsync() {
        return false;
    }
}
exports.NodeData = NodeData;
//# sourceMappingURL=nodeData.js.map